import React, {useEffect, useState} from "react";
import { IoMdSearch } from "react-icons/io";
import { Input, Button } from "@nextui-org/react";

import ChurchesBlock from "@/components/shared/churchs-block";
import DeaneriesBlock from "@/components/shared/deaneries-block";
import { DEOCESE_DEFAULT } from '@/components/helpers/constant.js';
import TuneFilterComponent from '../../public/icons/tuneFilter.js';
import Head from "next/head";
import {GlobalSettings} from "@/configuration/global-settings";
import SharedServiceInstance from "@/services/shared-service";
import {usePathname} from "next/navigation";
import imgStatic from '../../public/webp/chanh-toa.webp'

export default function ChurchDetail() {
    const [currentDeanery, setCurrentDeanery] = useState(DEOCESE_DEFAULT);
    const [churchName, setChurchName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [deaneries, setDeaneries] = useState({ total: 0});
    const [churchData, setChurchData] = useState({ total: 0});

    const filterChurches = async () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.get('page') && urlSearchParams.get('page') !== currentPage) {
            setCurrentPage(urlSearchParams.get('page'))
        }

        let payload = {
            page: currentPage,
            churchName: churchName,
            appointmentID: currentDeanery
        }
        const response = await fetch('api/churchs', {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json' }
        });

        setChurchData(await response.json());
    }

    useEffect(() => {
        if (currentDeanery) {
            filterChurches();
        }
    }, [currentDeanery, churchName, currentPage]);

    const pathname = usePathname()

    return <>
        <Head>
            <title>GIÁO PHẬN PHÚ CƯỜNG - GIÁO XỨ - GIÁO HẠT</title>
            <meta name="description" content="Chuyên trang truyền thông Giáo Phận Phú Cường"/>
            <meta name="keywords" content="Giáo Phận Phú Cường, giao phan phu cuong, giáo xứ, giáo hạt, phú cường"/>

            <meta property="og:url" content={`${GlobalSettings.Settings.WebServer}/${pathname}`}/>
            <meta property="og:image"
                  content={imgStatic}/>
            <meta property="og:title" content="GIÁO PHẬN PHÚ CƯỜNG - GIÁO XỨ - GIÁO HẠT"/>

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content="GIÁO PHẬN PHÚ CƯỜNG - GIÁO XỨ - GIÁO HẠT"/>
            <meta name="twitter:description" content="Chuyên trang truyền thông Giáo Phận Phú Cường"/>
            <meta name="twitter:image" content={imgStatic}/>
        </Head>
        {/* Search Church */}
        <div className="text-center pt-5">
            <h2 className="text-primary text-4xl font-bold py-5">TRA CỨU NHÀ THỜ</h2>

            <div className="mb-7">
                <Input
                    radius="lg"
                    classNames={{
                        input: [
                            "bg-white",
                            "text-black/90 dark:text-white/90",
                            "placeholder:text-default-700/50 dark:placeholder:text-white/60",
                        ],
                        innerWrapper: "bg-transparent",
                        inputWrapper: [
                            "shadow-xl",
                            "bg-white",
                            "dark:bg-default/60",
                            "backdrop-blur-xl",
                            "backdrop-saturate-200",
                            "hover:bg-default-200/70",
                            "dark:hover:bg-default/70",
                            "group-data-[focused=true]:bg-default-200/50",
                            "dark:group-data-[focused=true]:bg-default/60",
                            "!cursor-text",
                        ],
                    }}
                    startContent={
                        <IoMdSearch className="text-black ml-5" />
                    }
                    endContent={
                        <>
                            <div className="border-l-1 border-primary pl-3">
                                <Button size="sm" className="bg-inherit">
                                    <TuneFilterComponent />
                                </Button>
                            </div>
                        </>
                    }
                    onKeyDown={(e) => {
                        if (e.key === "Enter") setChurchName(e.target.value);
                    }}
                />
            </div>
            {/* Search input */}
        </div>

        {/* List Card Churches */}
        <DeaneriesBlock
            params={{
                currentDeanery: currentDeanery
            }}
            actions={{
                setDeaneriesData: setDeaneries,
                setCurrentPage: setCurrentPage,
                setCurrentDeanery: setCurrentDeanery
            }}
        />

        {/* List Church */}
        <div className="pt-5">
            <ChurchesBlock churchData={churchData} isPagination={true}
                actions={{setCurrentPage: setCurrentPage}}
            />
        </div>
    </>
}
